import React from 'react'
import Image from '@boltui/image'

import * as Styled from '../../Footer.styles'
import { cardLogos } from '../FooterUrls'

const ServiceFooter = () => (
  <Styled.Service>
    <div className='container container--row'>
      <div className='md-row xs-12--negative'>
        <Styled.ServiceBlock className='md-4'>
          <p>
            <strong>Returning an item</strong>
            <br />
            We’ve updated our returns policy in response to Covid-19.
            <br />
            <a
              title='Learn more about free and easy returns.'
              data-test='footer-free-easy-returns'
              href='/help/returns-and-refunds/'>
              Learn more here
            </a>
          </p>
        </Styled.ServiceBlock>
        <Styled.ServiceBlock className='md-4'>
          <p>
            <strong>Buy online using</strong>
            <br />
            We accept the following payment methods online
          </p>
          {cardLogos.map((card) => (
            <Image
              key={card.alt}
              alt={card.alt}
              src={`//media.4rgos.it/i/Argos/${card.src}`}
              height={32}
              width={48}
              lazy
              lazyWrapElement={'span'}
            />
          ))}
        </Styled.ServiceBlock>
        <div className='md-4 md-block xs-hidden'>
          <p aria-hidden='true'>
            <strong>Need Help?</strong>
            <br />
            <a title='Need Help? Ask us a question.' data-test='footer-ask-a-question' href='/help/'>
              <span aria-hidden='true'>Ask us a question</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </Styled.Service>
)

export default ServiceFooter
